<div sections class="flex flex-col flex-1">
  <mat-progress-bar
    *ngIf="isSearching"
    color="warn"
    mode="query"
  ></mat-progress-bar>
  <section class="flex justify-center" search-bar-section>
    <form
      [formGroup]="searchForm"
      class="w-full pt-4 px-4 md:px-0 max-w-5xl flex flex-col md:flex-row md:gap-2.5"
    >
      <mat-form-field class="flex-1">
        <mat-label>Search by names, location, or keywords</mat-label>
        <input
          formControlName="searchText"
          matInput
          placeholder="St. Mary's School"
          autocomplete="off"
          spellcheck="true"
          cdkFocusInitial
        />
        <button
          type="button"
          *ngIf="searchForm?.get(['searchText'])?.value"
          matSuffix
          mat-icon-button
          aria-label="Clear search text"
          (click)="clearSearchInput()"
        >
          <mat-icon>close</mat-icon>
        </button>

        <!--
          todo:
          1. change hint based on the tabs the user is currently on
          2. do dynamic placeholder text to show user what they can search
        -->
        <!-- <mat-hint></mat-hint> -->
      </mat-form-field>

      <div class="flex gap-2.5">
        <mat-form-field class="grow md:max-w-[212px]" appearance="fill">
          <mat-label>State</mat-label>
          <input
            type="text"
            placeholder="Delta"
            aria-label="State"
            matInput
            formControlName="state"
            [matAutocomplete]="autoState"
          />
          <button
            type="button"
            *ngIf="searchForm?.get(['state'])?.value"
            matSuffix
            mat-icon-button
            aria-label="Clear selected state"
            (click)="clearStateInput()"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete
            autoActiveFirstOption
            #autoState="matAutocomplete"
          >
            <mat-option value="All states">All states</mat-option>
            <mat-divider></mat-divider>
            <mat-option
              *ngFor="let option of filteredStates | async"
              [value]="option"
            >
              {{ option }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="searchForm?.get(['state'])?.hasError('required')">
            State is <strong>required</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="grow md:max-w-[212px]" appearance="fill">
          <mat-label>LGA</mat-label>
          <input
            type="text"
            placeholder=""
            aria-label="LGA"
            matInput
            formControlName="lga"
            [matAutocomplete]="autoLGA"
            (selectionchange)="lgaChanged($event)"
          />
          <button
            type="button"
            *ngIf="searchForm?.get(['lga'])?.value"
            matSuffix
            mat-icon-button
            aria-label="Clear selected LGA"
            (click)="clearLgaInput()"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete autoActiveFirstOption #autoLGA="matAutocomplete">
            <mat-option value="All LGAs">All LGAs</mat-option>
            <mat-divider></mat-divider>
            <mat-option
              *ngFor="let option of filteredLGAs | async"
              [value]="option"
            >
              {{ option }}
            </mat-option>
          </mat-autocomplete>
          <mat-hint *ngIf="!searchForm.get(['state'])?.value"
            >Choose state</mat-hint
          >
          <mat-hint *ngIf="lgaOptions.length"
            >{{ lgaOptions.length }} LGA{{
              lgaOptions.length === 1 ? '' : 's'
            }}</mat-hint
          >
          <mat-error *ngIf="searchForm.get(['lga'])?.hasError('required')">
            LGA is <strong>required</strong>
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Don't need button click. -->
      <!-- <button type="button" mat-icon-button color="secondary" aria-label="Search button">
                  <mat-icon>search</mat-icon>
              </button> -->
    </form>
  </section>

  <section search-result-section class="flex-1">
    <!-- loader is absolutely positioned, middle of search result section -->
    <div
      *ngIf="isFetchingResults; else searchResults"
      class="flex h-full justify-center items-center"
    >
      <mat-spinner diameter="55" color="warn"></mat-spinner>
    </div>

    <ng-template #searchResults>
      <mat-tab-group
        preserveContent="true"
        [(selectedIndex)]="selectedTabIndex"
        class="downnnn h-full [&>.mat-mdc-tab-body-wrapper]:flex-1"
      >
        <mat-tab
          labelClass="text-sm sm:text-base sm:font-medium | !px-2 !min-w-5 sm:!min-w-auto sm:!px-auto"
          aria-label="Items for sale"
          bodyClass="wow-testingg"
        >
          <ng-template mat-tab-label>
            <span
              class="inline-block sm:hidden"
              matBadgeSize="small"
              [matBadge]="results.sales.length"
              matBadgeOverlap="false"
              >Sales</span
            >

            <ng-container>
              <span class="!hidden sm:!inline-block">Sales</span>
              <mat-icon
                class="ms-0.5 !hidden sm:!inline-block"
                fontIcon="sell"
                aria-label="Sell icon"
                [matBadge]="results.sales.length"
                matBadgeOverlap="false"
              ></mat-icon>
            </ng-container>
          </ng-template>

          <div
            results-list
            sales-results
            class="sale-grid h-full w-full absolute overflow-y-auto p-3 sm:p-4"
            *ngIf="results?.sales?.length; else noSalesResults"
          >
            <app-feed-content
              *ngFor="let result of results?.sales; trackBy: trackById"
              [post]="result"
            >
            </app-feed-content>
          </div>
          <ng-template #noSalesResults>
            <p class="h-full flex items-center justify-center">
              {{ getEmptyResultText }}
            </p>
          </ng-template>
        </mat-tab>

        <mat-tab
          labelClass="text-sm sm:text-base sm:font-medium | !px-2 !min-w-5 sm:!min-w-auto sm:!px-auto"
          aria-label="Houses for rent"
        >
          <ng-template mat-tab-label>
            <!-- When we launch, update the selectedIndex check -->

            <span
              class="inline-block sm:hidden"
              matBadgeSize="small"
              [matBadge]="results.accommodations.length"
              matBadgeOverlap="false"
              >Houses</span
            >
            <ng-container>
              <span class="!hidden sm:!inline-block">Houses</span>
              <mat-icon
                class="ms-0.5 !hidden sm:!inline-block"
                fontIcon="apartment"
                aria-label="apartment icon"
                [matBadge]="results.accommodations.length"
                matBadgeOverlap="false"
              ></mat-icon>
            </ng-container>
          </ng-template>

          <div
            results-list
            accommodation-results
            class="house-grid h-full w-full absolute overflow-y-auto p-3 sm:p-4"
            *ngIf="
              results.accommodations.length > 0;
              else noAccommodationsResults
            "
          >
            <app-feed-content
              *ngFor="let result of results.accommodations; trackBy: trackById"
              [post]="result"
            >
            </app-feed-content>
          </div>
          <ng-template #noAccommodationsResults>
            <p class="h-full flex items-center justify-center">
              {{ getEmptyResultText }}
            </p>
          </ng-template>
        </mat-tab>

        <mat-tab
          labelClass="text-sm sm:text-base sm:font-medium | !px-2 !min-w-5 sm:!min-w-auto sm:!px-auto"
          aria-label="Corp members"
        >
          <ng-template mat-tab-label>
            <span
              class="inline-block sm:hidden"
              matBadgeSize="small"
              [matBadge]="results.corp_members.length"
              matBadgeOverlap="false"
              >Corpers</span
            >

            <ng-container>
              <span class="hidden sm:inline-block">Corpers</span>
              <mat-icon
                class="ms-0.5 !hidden sm:!inline-block"
                fontIcon="groups"
                aria-label="corp members icon"
                [matBadge]="results.corp_members.length"
                matBadgeOverlap="false"
              ></mat-icon>
            </ng-container>
          </ng-template>

          <div
            results-list
            corp-members-results
            class="h-full w-full absolute overflow-y-auto flex flex-wrap items-center gap-4 p-4 justify-center"
            *ngIf="results?.corp_members?.length; else noCorpMembersResults"
          >
            <mat-card
              *ngFor="let corp_member of results?.corp_members; trackBy: trackById"
              class="w-[300px]"
            >
              <mat-card-header>
                <img
                  mat-card-avatar
                  width="50"
                  height="50"
                  title="Profile picture of {{
                    corp_member?.nickname ||
                      corp_member?.first_name ||
                      'Corp member'
                  }}"
                  [ngSrc]="
                    corp_member?.Media?.url ||
                    'https://placehold.co/50x50/4ade80/000/?text=' +
                      (corp_member?.nickname ??
                        corp_member?.first_name ??
                        'C.')
                  "
                />
                <mat-card-title>{{
                  corp_member?.nickname || corp_member?.first_name || '-'
                }}</mat-card-title>
                <mat-card-subtitle
                  >Joined {{ corp_member?._age }}</mat-card-subtitle
                >
              </mat-card-header>
              <mat-card-content>
                <p>
                  {{ corp_member.bio ?? 'No bio.' }}
                </p>
              </mat-card-content>
            </mat-card>
          </div>
          <ng-template #noCorpMembersResults>
            <p class="h-full flex items-center justify-center">
              {{ getEmptyResultText }}
            </p>
          </ng-template>
        </mat-tab>

        <mat-tab
          labelClass="text-sm sm:text-base sm:font-medium | !px-2 !min-w-5 sm:!min-w-auto sm:!px-auto"
          aria-label="PPAs"
        >
          <ng-template mat-tab-label>
            <span
              class="inline-block sm:hidden"
              matBadgeSize="small"
              [matBadge]="results.ppas.length"
              matBadgeOverlap="false"
              >PPAs</span
            >

            <ng-container>
              <span class="!hidden sm:!inline-block">PPAs</span>

              <mat-icon
                class="ms-0.5 !hidden sm:!inline-block"
                fontIcon="home_work"
                aria-label="PPAs icon"
                [matBadge]="results.ppas.length"
                matBadgeOverlap="false"
              ></mat-icon>
            </ng-container>
          </ng-template>

          <!-- As on /ppa: compact rows on a phone, else /ppa's list or grid (ppaListClass) - inside the tab's scroller -->
          <div
            results-list
            class="h-full w-full absolute overflow-y-auto p-3 sm:p-4"
            *ngIf="results?.ppas?.length; else noPPAResults"
          >
            <div ppas-results [ngClass]="ppaListClass(isPhone, ppaView)">
              <app-ppa-content-card
                *ngFor="let ppa of results?.ppas; trackBy: trackById"
                class="!w-full"
                [ppa]="ppa"
                [layout]="isPhone ? 'row' : ppaView"
              ></app-ppa-content-card>
            </div>
          </div>
          <ng-template #noPPAResults>
            <p class="h-full flex items-center justify-center">
              {{ getEmptyResultText }}
            </p>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </ng-template>
  </section>
</div>
